import { useMachine } from "@xstate/svelte";
import { getContext } from "svelte";
import { purchaseflowStore } from "../store/purchaseflow";
const f = () => useMachine(purchaseflowStore);
export default function usePurchaseFlow() {
    const machine = getContext("purchaseFlowStore");
    if (!machine) {
        throw new Error("No Purchaseflow set, use PurchaseFlowProvider to set one");
    }
    return machine;
}
